import { Button } from '~/design-system/elements/Button/Button';

export interface SendButtonUIProps {
  disabled?: boolean;
  onClick?: () => void;
  /** 'stop' turns the send affordance into an abort control while the agent is generating. */
  mode?: 'send' | 'stop';
}

export function SendButtonUI({ disabled = false, onClick, mode = 'send' }: SendButtonUIProps) {
  const stopping = mode === 'stop';

  return (
    <Button
      type="button"
      variant="default"
      size="icon-xs"
      // Stop is always actionable: `disabled` encodes "nothing to send", which says nothing about
      // whether a run can be aborted — and the composer is empty for the whole run anyway.
      disabled={stopping ? false : disabled}
      onClick={onClick}
      aria-label={stopping ? 'Stop generating' : 'Send message'}
      leadIcon={stopping ? 'stop-square' : 'arrow-up'}
    />
  );
}
